import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { Instance } from "../../types/whatsapp";
import { Autocomplete } from "../Autocomplete";
import { Contact } from "../../types/whatsapp";
import * as Yup from "yup";

interface optionsFilterStatus {
  value: number;
  label: string;
}

export type FormikContact = {
  nome_contato: string;
  instance: Instance | null;
  numero: string;
  status: optionsFilterStatus;
  id?: number | null;
};
interface ContactUpdateProps {
  open: boolean;
  loadingAutocomplete: boolean;
  contact?: Contact | null;
  instances: Instance[];
  onClose: () => void;
  onSave: (contact: FormikContact) => void;
}

const VALIDATIONSCHEMA = Yup.object().shape({
  nome_contato: Yup.string().required("Informe o nome do contato"),
  numero: Yup.string().required("Informe o número"),
  status: Yup.object().required("Selecione o status de envio do número"),
  instance: Yup.object().required("Por favor selecione uma instância"),
});

const OPTIONSFILTERSTATUS: optionsFilterStatus[] = [
  { value: 0, label: "inativo" },
  { value: 1, label: "ativo" },
];

export function ContactUpdate({
  open,
  loadingAutocomplete,
  contact,
  instances,
  onClose,
  onSave,
}: ContactUpdateProps) {
  const handleSaveContact = (contactUpdate: FormikContact) => {
    onSave(contactUpdate);
  };

  const formik = useFormik({
    initialValues: {
      nome_contato: contact?.nome_contato || "",
      instance:
        (contact?.id_instancia
          ? instances.find((instance) => instance.id === contact.id_instancia)
          : null) || null,
      numero: contact?.numero || "",
      status: contact?.ativo_envio
        ? OPTIONSFILTERSTATUS[1]
        : OPTIONSFILTERSTATUS[0],
      id: contact?.id || null,
    },
    onSubmit: handleSaveContact,
    validationSchema: VALIDATIONSCHEMA,
    validateOnMount: false,
    validateOnChange: false,
  });

  const handleFormikValue = (name: string, value: any) => {
    formik.setFieldValue(name, value);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={"sm"}>
      <Box p="32px" component={"form"} onSubmit={formik.handleSubmit}>
        <DialogTitle sx={{ p: 0 }} fontSize="1.5rem">
          {contact ? "Detalhes do contato" : "Adicionar contato"}
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          <Box display="flex" flexDirection="column" p="32px 0" gap={3}>
            <TextField
              label="Nome"
              name="nome_contato"
              value={formik.values.nome_contato}
              onChange={({ target: { name, value } }) =>
                handleFormikValue(name, value)
              }
              fullWidth
              helperText={"Dê um nome para identificar este número"}
              error={Boolean(formik.errors.nome_contato)}
            />
            <Autocomplete
              fullWidth
              size="medium"
              label="Selecione a instância"
              name="instance"
              options={instances}
              value={formik.values.instance}
              getOptionLabel={(option) => option.nome}
              onChange={(_, instance) =>
                instance && handleFormikValue("instance", instance)
              }
              loading={loadingAutocomplete}
              helperText="Escolha a instância a que este número pertence"
              error={Boolean(formik.errors.instance)}
            />

            <TextField
              fullWidth
              label={"Número"}
              name="numero"
              onChange={({ target: { name, value } }) =>
                handleFormikValue(name, value)
              }
              value={formik.values.numero}
              error={Boolean(formik.errors.numero)}
              helperText="Informe o número do contato"
            />
          </Box>
        </DialogContent>

        <DialogActions
          sx={{ p: 0, display: "flex", justifyContent: "space-between" }}
        >
          <Button color="inherit" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="contained" type="submit">
            {contact ? "Editar" : "Salvar"}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
